import { type UseQueryOptions } from '@tanstack/react-query';

export type UseQueryFetchOptions = Pick<
    UseQueryOptions,
    | 'cacheTime'
    | 'staleTime'
    | 'refetchOnWindowFocus'
    | 'refetchOnMount'
    | 'refetchOnReconnect'
>;

export enum QueryKeys {
    HEALTH = 'health',
    GET_SUBSCRIPTION_GROUPS = 'get-subscription-groups',
    GET_ALL_SUBSCRIPTION_CATEGORY = 'get-all-subscription-category',
    GET_SUBCRIPTION_GROUP_BY_ID = 'get-subscription-group-by-id',

    GET_SUBSCRIPTION_PREFERENCE_FOR_CHANNEL = 'get-subscirption-preference-for-channel',
    GET_USER_SUBSCRIPTION_PREFERENCE = 'get-user-subscription-preference',
    UPDATE_USER_SUBSCRIPTION_PREFERENCE = 'update-user-subscription-preference',
    UPDATE_GLOBAL_PREFERENCE = 'update-global-preference',
    UNSUBSCRIBE_GROUP = 'unsubscribe-group',
}
